// Round colors for the UI
export const ROUND_COLORS = [
  'from-violet-500/20 to-purple-500/20 border-violet-500/30',
  'from-blue-500/20 to-cyan-500/20 border-blue-500/30',
  'from-emerald-500/20 to-teal-500/20 border-emerald-500/30',
  'from-indigo-500/20 to-violet-500/20 border-indigo-500/30'
];

// Season / preset configuration
export const CURRENT_PRESET_LABEL = '#1849 S28';

// Preset data for #1849 S28
// Powers stored as displayed values (in billions)
export const PRESET_TEAMS = [
  { name: '[DKNX] DARK NEXUS', power: 3.231, gifts: 13 },
  { name: '[TLOx] The Legends Order', power: 3.774, gifts: 15 },
  { name: '[iYi1] KAYI OBASI', power: 3.934, gifts: 14 },
  { name: '[IOBK]', power: 4.683, gifts: 19 },
  { name: '[kode] K Demon Hunters', power: 4.982, gifts: 20 },
  { name: '[KAWZ] korea and the world zone', power: 5.673, gifts: 21 },
  { name: '[BG1] Bloody Ghosts', power: 4.381, gifts: 15 },
  { name: '[PaGi] Pasukan Gigih', power: 4.061, gifts: 16 },
  { name: '[RNRN]', power: 3.146, gifts: 18 },
  { name: '[LEAT] Legio Aeternum', power: 4.694, gifts: 20 },
  { name: '[UNWZ] Unified Warzone', power: 4.706, gifts: 18 },
  { name: '[FiFa] Ghost and Family', power: 2.932, gifts: 14 },
  { name: '[UaN] Umbrella Network', power: 4.256, gifts: 17 },
  { name: '[VNHK] Viet Nam Hao Khi', power: 3.266, gifts: 13 },
  { name: '[Shhu] Shadowhunters', power: 4.184, gifts: 16 },
  { name: '[wuw] WOOOW', power: 5.265, gifts: 21 }
];

// Game configuration constants
export const TOTAL_TEAMS = 16;
export const TOTAL_ROUNDS = 4;
export const POWER_THRESHOLD_PERCENT = 10;
export const GIFTS_THRESHOLD = 2;
export const MAX_GIFTS = 99;
export const MIN_POWER = 0;
export const POWER_DISPLAY_DECIMALS = 3;
export const MAX_TEAM_NAME_LENGTH = 30;

